module.exports = __webpack_public_path__ + "static/media/document-duplicate.3bd3151b.svg";